const weKnowColdMainSliderSwiperWrapperClass = "we-know-cold-main-slider-swiper-wrapper"
const weKnowColdMainSliderScrollbarClass = "we-know-cold-main-slider-scrollbar";
const backBtnClass = "slider-back-btn";
const nextBtnClass = "slider-next-btn";

let industryProductSwiper;
initSwiperAfterLibLoad("." + weKnowColdMainSliderSwiperWrapperClass + " .swiper-wrapper-wrapper", {
      // Optional parameters
      direction: "horizontal",
      shortSwipes: true,
      simulateTouch: true,
      slideToClickedSlide: false,
      slidesPerView: "auto",
      slidesPerGroupAuto: true,
      spaceBetween: 24,
      loop: false,
      speed: 500,
      autoHeight: true,
      effect: "slide",
      allowSlideNext: true,
      allowTouchMove: true,
      // breakpoints: {
      //   // when window width is >= 768px (not mobile)
      //   768: {
      //     slidesPerView: "auto",
      //     slidesPerGroupAuto: true,
      //   },
      // },
      mousewheel: {
        enabled: true,
        forceToAxis: true,
      },
      // Navigation arrows
      navigation: {
          prevEl: "." + backBtnClass,
          nextEl: "." + nextBtnClass,
      },
      scrollbar: {
            el: "." + weKnowColdMainSliderScrollbarClass,
            hide: false,
      },
      on: {
      },
  }).then(result => industryProductSwiper = result);